import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'
import { FeatureToggle } from './featureToggles'

export const incentiveBudgetsViewAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.IncentiveBudgetsView],
  featureToggles: [FeatureToggle.IncentiveBudgets],
  requiresAllPartnersFullAccess: true,
}

export const incentiveBudgetsModifyAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.IncentiveBudgetsModify],
  featureToggles: [FeatureToggle.IncentiveBudgets],
  requiresAllPartnersFullAccess: true,
}
